<template>
  <div id="app">
    <NavTop/>
    <router-view></router-view>
    <Footer/>
  </div>
</template>

<script>
import NavTop from './components/Windows/NavTop.vue'
import Footer from './components/Windows/Footer.vue'

export default {
  name: 'App',
  components: {
    NavTop, Footer
  },
  created() {
    let path = this.$route.path;
    if (path.startsWith('/zh')) {
      this.$i18n.locale = 'zh';
    }
    if (path.startsWith('/en')) {
      this.$i18n.locale = 'en';
    }
  },
}
</script>

<style>
#app {
  font-family: 'TaiShifont', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  overflow: hidden;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

/* 淡入淡出效果 */
/* .router-transition-enter-active,
.router-transition-leave-active {
  transition: opacity 0.1s ease;
}

.router-transition-enter,
.router-transition-leave-to {
  opacity: 0;
} */

/* 滑动效果（可选） */
/* .router-transition-enter-active,
.router-transition-leave-active {
  transition: transform 0.3s ease, opacity 0.5s ease;
}

.router-transition-enter {
  transform: translateX(50px);
  opacity: 0;
}

.router-transition-leave-to {
  transform: translateX(-50px);
  opacity: 0;
} */
</style>
